exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color_blue {\n  background-color: #20a8d8;\n  height: 30px;\n  border: 1px solid #163a2f;\n  border-radius: 5px;\n  margin: 0 0 0.6rem;\n  padding: 5px 10px;\n  color: white;\n}\n.border_dark {\n  border: 1px solid #ffffff;\n  border-radius: 5px;\n  box-shadow: 0px 2px 4px rgba(148, 150, 151, 0.747);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-693e9372","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/common_components/packingBoxList.vue
// module id = 2078
// module chunks = 0